
import React, { createContext, useState, useContext, useEffect } from 'react';
import { Auth } from 'aws-amplify';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        checkUser();

        // Cleanup function
        return () => {
            // Perform cleanup when component unmounts
            setUser(null);
            localStorage.clear();
            sessionStorage.clear();
        };
    }, []);

    const checkUser = async () => {
        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            setUser(currentUser);
        } catch (error) {
            setUser(null);
        } finally {
            setIsLoading(false);
        }
    };
    const normalLogin = async (username, password) => {
        try {
            const user = await Auth.signIn(username, password);
            setUser(user);
            return user;
        } catch (error) {
            console.error("Error during normal login:", error);
            throw error; // Rethrow the error for handling in the component
        }
    };
    return (
        <AuthContext.Provider value={{ user, setUser, isLoading, normalLogin }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
